import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ForgotPasswordLink from '@spa/components/pages/auth/signup/shared/forgot-password/Link.vue'
import CartLoginDefaultNote from '@spa/components/pages/cart/components/login/default/CartLoginDefaultNote.vue'
import Vue, { VueConstructor } from 'vue'

import CartLoginMyColorNote from '../../components/login/mycolor/MyColorNote.vue'

export interface CartLoginTemplateParts {
  readonly note: VueConstructor
  readonly forgotPassword: VueConstructor
}

type DefaultTemplate = (opt?: Partial<CartLoginTemplateParts>) => (behavior: BehaviorConfig) => CartLoginTemplateParts
export const defaultTemplate: DefaultTemplate = (opt = {}) => behavior => ({
  note: defaultNote(behavior.groupLabel),
  forgotPassword: ForgotPasswordLink,
  ...opt,
})
const defaultNote = (hostName: string) => Vue.extend({
  components: { CartLoginDefaultNote },
  template: `<cart-login-default-note host-name="${hostName}" />`,
})

export const mycolorTemplate: CartLoginTemplateParts = {
  note: CartLoginMyColorNote,
  forgotPassword: ForgotPasswordLink,
}

export const vilbTemplate = defaultTemplate({
  note: defaultNote('美ラボ'),
})

export const fitowaTemplate = defaultTemplate({
  note: defaultNote('FITOWA'),
})

const empty = Vue.extend({
  name: 'EmptyCartLoginPart',
  template: '<div></div>',
})

export const loadingTemplate: CartLoginTemplateParts = {
  note: empty,
  forgotPassword: empty,
}
